const BackendURLFunc = () => {
  // Build-mode driven, NOT hostname driven: the packaged desktop renderer is
  // served from http://127.0.0.1:<port> (local SSR), which must still talk to
  // the production backends. Dev build -> local backend, prod build -> domain.
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_BACKEND_URL ?? "";
  }
  return import.meta.env.VITE_BACKEND_URL_DOMAIN ?? "";
};

export const BackendURL = BackendURLFunc();

const storageBaseFromEnv = () => {
  const v = import.meta.env?.VITE_STORAGE_BASE_URL;
  if (v != null && String(v).trim() !== "") {
    return String(v).trim().replace(/\/$/, "");
  }
  return "https://storage.doitify.com";
};

export const StorageBaseURL = storageBaseFromEnv();
